import * as api from "app/api/functions"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest, select } from "redux-saga/effects"
import * as notificationActions from "app/redux/notifications/notifications.actions"
import { PracticeFunction } from "app/models/practice"
import * as actions from "./functions.actions"
import * as functionsSelectors from "./functions.selectors"
import { handleError } from "../errorHandler/errorHandler.saga"
import * as filterActions from "../filter/filter.actions"

export function* getFunctionsFlow(): SagaIterator {
  try {
    const response = yield call(api.getFunctions)
    yield put(actions.getFunctionsSuccess(response?.data))
    const functionNames = response?.data.map((functionItem: PracticeFunction) => functionItem.name)
    yield put(
      filterActions.setFilterableFields({
        filterableField: "functions",
        filterableFieldsValues: functionNames,
      }),
    )
  } catch (e) {
    yield put(actions.getFunctionsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchFunctionsFlow(action: actions.PatchFunctionsAction): SagaIterator {
  try {
    const { payload } = action
    const response = yield call(api.patchFunctions, payload)
    yield put(actions.patchFunctionsSuccess(response?.data))
    const functions = yield select(functionsSelectors.getFunctions)
    const functionNames = functions.map((functionItem: PracticeFunction) => functionItem.name)
    yield put(
      filterActions.setFilterableFields({
        filterableField: "functions",
        filterableFieldsValues: functionNames,
      }),
    )
    yield put(
      notificationActions.show({
        id: "postFunctionsSuccess",
        message: "confirmationdialog.function.update.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.patchFunctionsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchFunctionsOrderFlow(action: actions.PatchFunctionsOrderAction): SagaIterator {
  try {
    const { payload } = action
    const { data } = yield call(api.patchFunctionsOrder, payload)
    yield put(actions.patchFunctionsOrderSuccess(data))
    yield put(actions.getFunctions())
    const functions = yield select(functionsSelectors.getFunctions)
    const functionNames = functions.map((functionItem: PracticeFunction) => functionItem.name)
    yield put(
      filterActions.setFilterableFields({
        filterableField: "functions",
        filterableFieldsValues: functionNames,
      }),
    )
    yield put(
      notificationActions.show({
        id: "postFunctionsSuccess",
        message: "confirmationdialog.function.update.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.patchFunctionsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postFunctionsFlow(action: actions.PostFunctionsAction): SagaIterator {
  try {
    const { payload } = action
    const response = yield call(api.postFunction, payload)
    yield put(actions.postFunctionsSuccess(response?.data))
    const functionNames = yield select(functionsSelectors.getFunctions)
    yield put(
      filterActions.setFilterableFields({
        filterableField: "functions",
        filterableFieldsValues: functionNames,
      }),
    )
    yield put(
      notificationActions.show({
        id: "postFunctionsSuccess",
        message: "confirmationdialog.function.create.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.postFunctionsFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* functionsSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getFunctionsFlow)
  yield takeLatest(actions.Types.PATCH, patchFunctionsFlow)
  yield takeLatest(actions.Types.PATCH_ORDER, patchFunctionsOrderFlow)
  yield takeLatest(actions.Types.POST, postFunctionsFlow)
}
